// extracted by mini-css-extract-plugin
export default {"container":"NewsCategoryNavigation-module--container--RK8H1","nav":"NewsCategoryNavigation-module--nav--e4dTK","active":"NewsCategoryNavigation-module--active--uIWX3"};